import { useState, useEffect } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

/**
 * Custom hook to get browser fingerprint using FingerprintJS
 * @returns {string|null} - The fingerprint visitor ID or null if not ready
 */
export const useFingerprint = () => {
  const [fingerprint, setFingerprint] = useState(null);

  useEffect(() => {
    const getFingerprint = async () => {
      try {
        // Load the FingerprintJS agent
        const fp = await FingerprintJS.load();

        // Get the visitor identifier
        const result = await fp.get();

        // Set the fingerprint
        setFingerprint(result.visitorId);
      } catch (error) {
        console.error("Error getting fingerprint:", error);
        // Set a fallback value if fingerprinting fails
        setFingerprint(null);
      }
    };

    getFingerprint();
  }, []);

  return fingerprint;
};
